module.exports = __webpack_public_path__ + "img/Kerze_Grau.57f871d4.png";